import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { ModalStyle, OverlayStyle } from "./ModalStyled";
import ModalHeader from "./ModalHeader";
import ModalContent from "./ModalContent";
import { useSelector } from "react-redux";
import { getModalData } from "./slice/selectors";
import { ModalController } from "./ModalController/ModalController";
import { getTenantCredentials } from "../Tenant/selectors";
import { getStylesFromTenant } from "../../utils/tenant";
import { useAppDispatch } from "../../store/store";
import { onCloseModal } from "./slice/ModalSlice";
import { MODAL_ROOT_CAUSE } from "../../entities/Modal";
import { setNameHasError } from "../Mixture/MixtureSlice";

const ModalComponent: React.FC = () => {
  const dispatch = useAppDispatch();
  const credentials = useSelector(getTenantCredentials);
  const { isOpen, modalType, content, rootCause } = useSelector(getModalData);
  const { name = "" } = content;

  const [ModalNode, setModalNode] = useState<React.ReactNode>();

  useEffect(() => {
    const modal = ModalController.find((item) => item.type === modalType);
    setModalNode(modal && modal.component && modal.component);
  }, [isOpen, modalType]);

  const { color } = getStylesFromTenant(
    credentials && credentials.webshopDesigns,
  );

  const onCloseModalHandler = () => {
    if (rootCause === MODAL_ROOT_CAUSE.MIX_NAME_MISSING) {
      dispatch(setNameHasError(true));
    }
    dispatch(onCloseModal());
  };
  return (
    <Modal
      isOpen={isOpen}
      appElement={document.getElementById("root") as HTMLElement}
      contentElement={(props, children) => (
        <ModalStyle {...props}>{children}</ModalStyle>
      )}
      overlayElement={(props, contentElement) => (
        <OverlayStyle {...props}>{contentElement}</OverlayStyle>
      )}
      closeTimeoutMS={200}
      shouldCloseOnOverlayClick={true}
      onRequestClose={() => onCloseModalHandler()}
    >
      <ModalHeader style={{ color }} title={name} />
      <ModalContent style={{ color }}>{ModalNode}</ModalContent>
    </Modal>
  );
};

export default ModalComponent;
